import RAPIER from "@dimforge/rapier3d-compat";
import { PhysicsWorld } from "../../../physics/physics_world.js";
import { RigidMotion } from "../../../physics/physics_protocol.js";

import { ElevatorConfig, PhysicsTable } from "../../../entities/physics_table.js";

export const ELEVATOR_CONFIG: ElevatorConfig = {
  riseHeight: 1.1,
  periodSec: 3.6,
};

export class TableElevator
{
  private time = 0;
  private height = 0;

  constructor(
    private readonly table: PhysicsTable,
    private readonly config: ElevatorConfig,
    private readonly get_bodies: () => Iterable<RAPIER.RigidBody>
  )
  {}

  public step( dt: number ): void
  {
    this.time += dt;

    const period = Math.max( this.config.periodSec, 0.1 );

    const next = this.config.riseHeight * 0.5
      * ( 1 - Math.cos( this.time * ( 2 * Math.PI / period ) ) );

    const delta = next - this.height;
    this.height = next;

    if ( delta !== 0 )
      this.carry( delta );

    this.table.setElevation( this.height );
  }

  private carry( delta: number ): void
  {
    const moved = this.moved;
    moved.length = 0;
    for ( const body of this.get_bodies() )
    {
      if ( !body.isValid() )
        continue;

      if ( this.table.isOutside( body.translation() ) )
        continue;

      moved.push( body );
    }

    this.motion.dy = delta;
    PhysicsWorld.moveBodies( moved, this.motion );
    moved.length = 0;
  }

  private readonly moved: RAPIER.RigidBody[] = [];
  private readonly motion: RigidMotion = { rotate: false, planar: false, px: 0, py: 0, pz: 0, qx: 0, qy: 0, qz: 0, qw: 1, dx: 0, dy: 0, dz: 0 };
}
